import React, { FunctionComponent, MouseEvent } from 'react';

import classnames from 'classnames';

import { LeftNav } from 'common/chrome/left-nav/LeftNav';
import { TopNav } from 'common/chrome/top-nav/TopNav';
import { JobsNotifier } from 'common/jobs/jobs-notifier/JobsNotifier';
import { MessageBar } from 'common/message-bar/MessageBar';

import 'common/chrome/Chrome.scss';
import 'core/theme/Theme.scss';

export const Chrome: FunctionComponent = () => {
    const [isNavOpen, setIsNavOpen] = React.useState(false);

    const chromeClassnames = classnames('r4e-chrome', {
        'state-nav-open': isNavOpen,
    });

    const handleNavToggle = (e: MouseEvent): void => {
        setIsNavOpen(!isNavOpen);
        e.preventDefault();
    };

    return (
        <div className={chromeClassnames}>
            <TopNav onNavToggle={handleNavToggle} />
            <LeftNav isNavOpen={isNavOpen} onNavToggle={handleNavToggle} />
            <MessageBar />
            <JobsNotifier />
        </div>
    );
};
